/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Changelogeyebrow1Inputs */

const id_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejak audit`)
};

const ms_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejak audit`)
};

const da_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisionsspor`)
};

const de_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfpfad`)
};

const en_us2_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail`)
};

const es_es2_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de auditoría`)
};

const es_mx2_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de auditoría`)
};

const fil_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail`)
};

const fr_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste d'audit`)
};

const it_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia di controllo`)
};

const hu_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naplózás`)
};

const nl_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audittrail`)
};

const no_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisjonsspor`)
};

const pl_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ślad audytowy`)
};

const pt_br2_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trilha de auditoria`)
};

const pt_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de auditoria`)
};

const ro_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal de audit`)
};

const fi_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkastuspolku`)
};

const sv_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisionsspår`)
};

const vi_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dấu vết kiểm toán`)
};

const tr_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetim izi`)
};

const cs_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditní stopa`)
};

const bg_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одитен запис`)
};

const ru_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиторский след`)
};

const uk_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиторський слід`)
};

const ar_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسار المراجعة`)
};

const hi_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडिट ट्रेल`)
};

const th_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ร่องรอยการตรวจสอบ`)
};

const ja_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`監査証跡`)
};

const zh_cn2_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审计追踪`)
};

const zh_hant1_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稽核追蹤`)
};

const ko_sandboxes_changelogeyebrow1 = /** @type {(inputs: Sandboxes_Changelogeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`감사 추적`)
};

/**
* | output |
* | --- |
* | "Audit trail" |
*
* @param {Sandboxes_Changelogeyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_changelogeyebrow1 = /** @type {((inputs?: Sandboxes_Changelogeyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Changelogeyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_changelogeyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_changelogeyebrow1(inputs)
	if (locale === "da") return da_sandboxes_changelogeyebrow1(inputs)
	if (locale === "de") return de_sandboxes_changelogeyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_changelogeyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_changelogeyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_changelogeyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_changelogeyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_changelogeyebrow1(inputs)
	if (locale === "it") return it_sandboxes_changelogeyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_changelogeyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_changelogeyebrow1(inputs)
	if (locale === "no") return no_sandboxes_changelogeyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_changelogeyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_changelogeyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_changelogeyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_changelogeyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_changelogeyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_changelogeyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_changelogeyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_changelogeyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_changelogeyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_changelogeyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_changelogeyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_changelogeyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_changelogeyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_changelogeyebrow1(inputs)
	if (locale === "th") return th_sandboxes_changelogeyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_changelogeyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_changelogeyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_changelogeyebrow1(inputs)
	return ko_sandboxes_changelogeyebrow1(inputs)
});
export { sandboxes_changelogeyebrow1 as "sandboxes.changelogEyebrow" }